import React from 'react';
import PageTitle from '../../FormElements/PageTitle';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import FormSection from '../../FormElements/FormSection';
import FormSubmit from '../../FormElements/FormSubmit';
import Label from '../../FormElements/Label';
import TextInput from '../../FormElements/TextInput';
import DropdownList from '../../FormElements/DropdownList';
import PrimaryButton from '../../Buttons/PrimaryButton';
import SecondaryButton from '../../Buttons/SecondaryButton';

export default class PropertyForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			propertyId: null,
			name: '',
			address_1: '',
			address_2: '',
			city: '',
			propertyState: 'Hawaii',
			postal_code: '',
			county: '',
			errorsList: [],
			fieldErrors: {}
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.createPropertyOwnership = this.createPropertyOwnership.bind(this);
		this.createPowerOfAttorney = this.createPowerOfAttorney.bind(this);
		this.createBusinessLicenseSurvey = this.createBusinessLicenseSurvey.bind(
			this
		);
		this.createSubscription = this.createSubscription.bind(this);
	}

	componentDidMount() {
		if (this.props.isEditing) {
			this.loadData();
		}
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render() {
		// console.log('PropertyForm', this.props, this.state);
		return (
			<div className="PropertyForm w-full py-4">
				<PageTitle
					title={
						this.props.isEditing ? (
							'Update your property details'
						) : (
							'Add your property details'
						)
					}
				/>
				<GlobalErrorsBox globalErrors={this.state.errorsList} />
				<FormSection>
					<Label htmlFor="name">Property Nickname *</Label>
					<TextInput
						id="name"
						name="name"
						value={this.state.name}
						onChange={this.onChange}
						placeholder="e.g. Surfer's Hideaway"
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="address_1">Address Line 1 *</Label>
					<TextInput
						id="address_1"
						name="address_1"
						value={this.state.address_1}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="address_2">Address Line 2</Label>
					<TextInput
						id="address_2"
						name="address_2"
						value={this.state.address_2}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="city">City *</Label>
					<TextInput
						id="city"
						name="city"
						value={this.state.city}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="propertyState">State *</Label>
					<TextInput
						id="propertyState"
						name="propertyState"
						value={this.state.propertyState}
						onChange={this.onChange}
						readOnly={true}
					/>
					<Label htmlFor="postal_code">Zip Code *</Label>
					<TextInput
						id="postal_code"
						name="postal_code"
						value={this.state.postal_code}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
					<Label htmlFor="county">County *</Label>
					<TextInput
						id="county"
						name="county"
						value={this.state.county}
						onChange={this.onChange}
						fieldErrors={this.state.fieldErrors}
					/>
				</FormSection>
				<div className="grid">
					<div className="lg:justify-self-end">
						<FormSubmit
							onSubmit={this.onSubmit}
							label={
								this.props.isEditing ? (
									'Save changes'
								) : (
									'Add property and continue'
								)
							}
						/>
					</div>
				</div>
				{/*	<PrimaryButton
						label="Test - Back"
						onClick={this.props.backLocation}
					/>
					<SecondaryButton
						label="Test - Continue"
						onClick={this.props.continueLocation}
					/> */}
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		e.preventDefault();
		e.stopPropagation();

		$.ajax({
			type: 'POST',
			url: this.props.isEditing
				? this.props.update_property_endpoint.replace('id', this.props.id)
				: this.props.create_property_endpoint,
			dataType: 'json',
			data: {
				property: {
					name: this.state.name,
					address_1: this.state.address_1,
					address_2: this.state.address_2,
					city: this.state.city,
					state: this.state.propertyState,
					postal_code: this.state.postal_code,
					county: this.state.county,
					account_id: this.props.accountId
				}
			},
			error: (response) => {
				// console.log('Create property call failed.', response.responseJSON);
				this.setState({
					// errorsList: response.responseJSON.errors, // Enable for errors list
					fieldErrors: response.responseJSON.field_errors // Enable for field errors
				});
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			}
		}).done((response, status) => {
			// console.log('Create property call successful.', response, status);
			this.setState({ propertyId: response.data.id });

			// Conditionally invoke the functions
			if (!this.props.isEditing) {
				this.createPropertyOwnership(e);
				this.createPowerOfAttorney(e);
				this.createBusinessLicenseSurvey(e);
				this.createSubscription(e);
				this.props.continueLocation(this.state.propertyId);
			}

			if (this.props.isEditing) {
				window.location.href = `/properties/${this.state.propertyId}`;
			}
		});
	}

	createPropertyOwnership(e) {
		// console.log('Create property ownership call stated...');

		$.ajax({
			type: 'POST',
			url: this.props.create_property_ownership_endpoint,
			dataType: 'json',
			data: {
				property_ownership: {
					property_id: this.state.propertyId,
					ownership_type: '',
					owner_1_first_name: this.props.firstName,
					owner_1_last_name: this.props.lastName,
					owner_1_phone_number: this.props.phoneNumber,
					owner_1_email: this.props.email
				}
			},
			error: (response) => {
				// console.log(
				// 	'Create property ownership call failed.',
				// 	response,
				// 	response.responseJSON.errors
				// );
			}
		}).done((response, status) => {
			// console.log(
			// 	'Create property ownership call successful.',
			// 	response,
			// 	status
			// );
		});
	}

	createPowerOfAttorney(e) {
		// console.log('Create POA call stated...');

		$.ajax({
			type: 'POST',
			url: this.props.create_power_of_attorney_endpoint,
			dataType: 'json',
			data: {
				poa: {
					property_id: this.state.propertyId,
					name: 'POA',
					status: 'Unsigned'
				}
			},
			error: (response) => {
				// console.log(
				// 	'Create POA call failed.',
				// 	response,
				// 	response.responseJSON.errors
				// );
			}
		}).done((response, status) => {
			// console.log('Create POA call successful.', response, status);
		});
	}

	createBusinessLicenseSurvey(e) {
		// console.log('Create business license survey call stated...');

		$.ajax({
			type: 'POST',
			url: this.props.create_business_license_survey_endpoint,
			dataType: 'json',
			data: {
				business_license_survey: {
					property_id: this.state.propertyId
				}
			},
			error: (response) => {
				// console.log(
				// 	'Create business license survey call failed.',
				// 	response,
				// 	response.responseJSON.errors
				// );
			}
		}).done((response, status) => {
			// console.log(
			// 	'Create business license survey call successful.',
			// 	response,
			// 	status
			// );
		});
	}

	createSubscription(e) {
		// console.log('Create subscription call stated...');

		$.ajax({
			type: 'POST',
			url: this.props.create_subscription_endpoint,
			dataType: 'json',
			data: {
				subscription: {
					property_id: this.state.propertyId,
					subscription_type: 'RBO',
					status: 'Pending',
					subscription_fee_amount: 25
				}
			},
			error: (response) => {
				// console.log(
				// 	'Create subscription call failed.',
				// 	response,
				// 	response.responseJSON.errors
				// );
			}
		}).done((response, status) => {
			// console.log('Create subscription call successful.', response, status);
		});
	}

	loadData() {
		$.ajax({
			type: 'GET',
			url: this.props.get_property_endpoint.replace('id', this.props.id)
		}).done((payload) => {
			const result = payload;
			// console.log('Property loadData done', result);
			this.setState({
				propertyId: result.data.id,
				name: result.data.name,
				address_1: result.data.address_1,
				address_2: result.data.address_2,
				city: result.data.city,
				propertyState: result.data.state,
				postal_code: result.data.postal_code,
				county: result.data.county
			});
		});
	}
}
